import React, { useRef } from 'react'
import { isIOS } from 'react-device-detect'

import PropTypes from 'prop-types'
import { ReelWhite } from '@shared/components/ctIcons'
import ReelArticle from '@shared/components/reelSlider/reelArticle'
import ReelImage from '@shared/components/reelSlider/reelImage'
import ReelTwitter from '@shared/components/reelSlider/reelTwitter'
import ReelVideo from '@shared/components/reelSlider/reelVideo'
import ReelYoutube from '@shared/components/reelSlider/reelYoutube'
import { S3_PREFIX } from '@shared/constants'

function ReelCard({ data, styles, isCurrent }) {
  const videoRef = useRef(null)

  function handlePlayPush() {
    if (videoRef.current && (isCurrent || data?.sHashId === window.currentHashId)) {
      videoRef.current?.play()
      if (window.isMutedClicked) {
        if (window.isMuted) videoRef.current.mute()
        else if (!isIOS) videoRef.current.unMute()
      }
    } else if (videoRef.current) {
      videoRef.current?.pause()
    }
  }
  function getType() {
    if (data?.eStoryType === 'y') {
      return (
        <ReelYoutube
          isPreview
          isCurrent={isCurrent}
          styles={styles}
          key={data?.iPostId}
          id={data?.iPostId}
          ref={videoRef}
            onPlayerReady={handlePlayPush}
        />
      )
    } else if (data?.eStoryType === 'x') {
      if (data?.aMedia?.length === 1) {
        const media = data?.aMedia?.[0]
        if (media?.eMediaType === 'i') {
          return <ReelImage src={media?.sImageURL} styles={styles} loading="lazy" />
        } else {
          const m3u8 = media?.aVariants?.find((x) => x?.sContentType === 'application/x-mpegURL')
          const mp4 = media?.aVariants?.find((x) => x?.sContentType === 'video/mp4' && x?.sURL?.includes('720x1280'))
          return (
            <ReelVideo
              isPreview
              sHashId={data?.sHashId}
              isCurrent={isCurrent}
              url={mp4?.sURL || m3u8?.sURL}
              thumbnail={media?.sThumbnail}
              ref={videoRef}
            />
          )
        }
      } else return <ReelTwitter data={data} styles={styles} />
    } else if (data?.eStoryType === 'ci') {
      const media = data?.aMedia?.[0]
      return <ReelImage src={S3_PREFIX + media?.sImageURL} alt="Img" styles={styles} loading="lazy" />
    } else if (data?.eStoryType === 'a') {
      return <ReelArticle data={data} styles={styles} />
    } else return null
  }
  return (
    <>
      <div className={`position-relative mw-100 overflow-hidden ${styles.wrap}`}>
        {getType()}
        <div className={`${styles.overlayContent} position-absolute top-0 start-0`}>
          <ReelWhite/>
        </div>
        <div className={`${styles.overlayContent} position-absolute bottom-0 start-0`}>
          {data?.eStoryType !== 'a' && (
            <div className={`${styles.overlayDescription}`}>
              <p onDoubleClick={(e) => e.stopPropagation()} className={'m-0'}>
                {data?.sTitle}
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

ReelCard.propTypes = {
  data: PropTypes.object,
  styles: PropTypes.object,
  isCurrent: PropTypes.bool
}

export default ReelCard
